export default "__VITE_ASSET__39503adf__"